import "./footer.css"
import logo from "./assets/Logo-Gerais-Net-Símbolo-branco.png";

const Rodape = () => {
    return (
      <div className="geraisnet-footer">
        <a
          href="https://wa.me/5538998988942"
          target="_blank"
          rel="noopener noreferrer"
          className="geraisnet-whatsapp-btn"
        >
          <i className="fab fa-whatsapp"></i>
          <span className="geraisnet-whatsapp-text">Fale Conosco</span>
        </a>
  
        <div className="geraisnet-footer-container">
          {/* COLUNA 1 - LOGO */}
          <div className="geraisnet-footer-col">
            <div className="geraisnet-footer-logo">
              <div className="geraisnet-logo-icon">
               <img src={logo} alt="Gerais Net Logo" className="logo-img-footer" /></div>
              <div className="geraisnet-logo-text">
               
                <p className="geraisnet-logo-slogan">
                  Conectando pessoas, impulsionando o futuro digital
                </p>
              </div>
            </div>
  
            <p className="geraisnet-footer-desc">
              Há mais de meia decada levando internet de alta velocidade e qualidade
              para Santo Antônio do Retiro e região.
            </p>
  
            <div className="geraisnet-social-icons">
              <a
                href="https://www.facebook.com"
                target="_blank"
                rel="noopener noreferrer"
                className="geraisnet-social-link"
              >
                <i className="fab fa-facebook-f"></i>
              </a>
              <a
                href="https://www.instagram.com/gerais_net/"
                target="_blank"
                rel="noopener noreferrer"
                className="geraisnet-social-link"
              >
                <i className="fab fa-instagram"></i>
              </a>
              <a
                href="https://wa.me/5538998988942"
                target="_blank"
                rel="noopener noreferrer"
                className="geraisnet-social-link"
              >
                <i className="fab fa-whatsapp"></i>
              </a>
            </div>
          </div>
  
          {/* COLUNA 2 - LINKS */}
          <div className="geraisnet-footer-col">
            <h4 className="geraisnet-col-title">Links Rápidos</h4>
            <ul className="geraisnet-footer-links">
              <li>
                <a href="#inicio" className="geraisnet-footer-link">
                  <i className="fas fa-home"></i> Home
                </a>
              </li>
              <li>
                <a href="#planos" className="geraisnet-footer-link">
                  <i className="fas fa-bolt"></i> Planos de Internet
                </a>
              </li>
              <li>
                <a href="#sobre" className="geraisnet-footer-link">
                  <i className="fas fa-building"></i> Quem Somos
                </a>
              </li>
              <li>
                <a href="#atendimento" className="geraisnet-footer-link">
                  <i className="fas fa-headset"></i> Atendimento
                </a>
              </li>
              <li>
                <a href="#planos" className="geraisnet-footer-link">
                  <i className="fas fa-shopping-cart"></i> Contratar Plano
                </a>
              </li>
            </ul>
          </div>
  
          {/* COLUNA 3 - ATENDIMENTO */}
          <div className="geraisnet-footer-col">
            <h4 className="geraisnet-col-title">Atendimento</h4>
  
            <div className="geraisnet-contact-item">
              <i className="fas fa-phone-alt"></i>
              <div>
                <p className="geraisnet-contact-text">Telefone</p>
                <a href="tel:+5538998988942" className="geraisnet-contact-detail">
                  (38) 99898-8942
                </a>
              </div>
            </div>
  
            <div className="geraisnet-contact-item">
              <i className="fab fa-whatsapp"></i>
              <div>
                <p className="geraisnet-contact-text">WhatsApp</p>
                <a
                  href="https://wa.me/5538998988942"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="geraisnet-contact-detail"
                >
                  Fale Conosco
                </a>
              </div>
            </div>
  
            <div className="geraisnet-contact-item">
              <i className="fas fa-clock"></i>
              <div>
                <p className="geraisnet-contact-text">Horário</p>
                <p className="geraisnet-contact-detail">
                  Seg a Sex: 8h às 16h <br />
                 
                </p>
              </div>
            </div>
  
            <p className="geraisnet-support-text">
              <i className="fas fa-check-circle"></i> Suporte rápido e especializado
            </p>
          </div>
  
          {/* COLUNA 4 - CONTATO */}
          <div className="geraisnet-footer-col">
            <h4 className="geraisnet-col-title">Contato</h4>
  
            <div className="geraisnet-contact-item">
              <i className="fas fa-map-marker-alt"></i>
              <div>
                <p className="geraisnet-contact-text">Endereço</p>
                <p className="geraisnet-contact-detail">
                  Santo Antônio do Retiro – MG
                </p>
              </div>
            </div>
  
            <div className="geraisnet-contact-item">
              <i className="fas fa-envelope"></i>
              <div>
                <p className="geraisnet-contact-text">E-mail</p>
                <a
                  href="mailto:geralsnetrotmg@gmail.com"
                  className="geraisnet-contact-detail"
                >
                  geraisnetretiro@gmail.com
                </a>
              </div>
            </div>
  
            <a
              href="https://wa.me/5538998988942"
              target="_blank"
              rel="noopener noreferrer"
              className="geraisnet-whatsapp-cta"
            >
              <i className="fab fa-whatsapp"></i>
              <span>Atendimento via WhatsApp</span>
            </a>
          </div>
        </div>
  
        
      </div>
    );
  };
  
  export default Rodape;
  